<template>
  <div>Log 页面</div>
</template>

<script>
export default { name: 'Log' };
</script>
